import MuiFormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';

function FormControlLabel(props: FormControlLabelProps) {
  return <MuiFormControlLabel {...props} />;
}

export default FormControlLabel;
